import screensaver from './screensaver'
import {closeMenu} from './header-desktop'

const SELECTORS = {
  SEARCH_INPUT: '#NavDesktopSearchInput',
  NAV_DESKTOP_WRAPPER: '.nav-desktop-wrap',
  NAV_ITEM: '.nav-desktop__item',
  NAV_PANE: '.nav-desktop__pane',
  NAV_SUBLIST: '.nav-desktop__sublist',
  SLEEP_MODE_BTN: '#SleepModeBtnDesktop',
}

const NAV_ITEM_ACTIVE_CLASS = 'nav-desktop__item--is-active'
const NAV_PANE_ACTIVE_CLASS = 'nav-desktop__pane--is-active'
const NAV_SUBLIST_ACTIVE_CLASS = 'nav-desktop__sublist--is-active'

export default () => {

  $('[data-target]').on({
    mouseover: (event) => {
      const handle = event.currentTarget.dataset.target
      const scrollTop = $(window).scrollTop()
      const elementOffset = Math.floor(Number($(event.currentTarget).offset().top))
      const distance = (elementOffset - scrollTop - 1)
      setActiveMenuTier(handle, distance)
    },
  })

  $(SELECTORS.NAV_ITEM).on('mouseover', function() {
    const currentLevel = Number($(this).closest(SELECTORS.NAV_PANE).attr('data-level')) || 0

    if ($(this).attr('data-target') == null) {
      $(`${SELECTORS.NAV_PANE}[data-level=${currentLevel + 1}]`)
        .removeClass(NAV_PANE_ACTIVE_CLASS)
        .find(SELECTORS.NAV_SUBLIST)
        .removeClass(NAV_SUBLIST_ACTIVE_CLASS)
    }
  })

  $(SELECTORS.SEARCH_INPUT).on({
    focus: (event) => {
      $(event.currentTarget).closest(SELECTORS.NAV_ITEM).addClass(NAV_ITEM_ACTIVE_CLASS)
    },
    blur: (event) => {
      $(event.currentTarget).closest(SELECTORS.NAV_ITEM).removeClass(NAV_ITEM_ACTIVE_CLASS)
    },
  })

  $(SELECTORS.SLEEP_MODE_BTN).on('click', (event) => {
    setTimeout(screensaver.start, 400)
  })
}

function setActiveMenuTier(handle, topOffset = 0) {
  const $allSubMenus = $(SELECTORS.NAV_SUBLIST)
  const $subMenu = $(`${SELECTORS.NAV_SUBLIST}[data-parent="${handle}"]`)
  const $subMenuParent = $(`[data-target="${handle}"]`).closest(SELECTORS.NAV_SUBLIST)
  const $allSubMenuPanes = $(SELECTORS.NAV_PANE)
  const $subMenuPane = $subMenu.closest(SELECTORS.NAV_PANE)

  const navItemLevel = Number($(`${SELECTORS.NAV_ITEM}[data-target="${handle}"]`)
    .closest('[data-level]')
    .attr('data-level')) || 0

  if (navItemLevel === 0) {
    $allSubMenuPanes.removeClass(NAV_PANE_ACTIVE_CLASS)
  }

  $subMenuPane
    .addClass(NAV_PANE_ACTIVE_CLASS)
    .css('top', `${topOffset}px`)

  $allSubMenus.removeClass(NAV_SUBLIST_ACTIVE_CLASS)
  $subMenuParent.addClass(NAV_SUBLIST_ACTIVE_CLASS)
  $subMenu.addClass(NAV_SUBLIST_ACTIVE_CLASS)
}



// WEBPACK FOOTER //
// ./nav-desktop.js